<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid" />Slider
        <div class="card-header-actions">
          <CLink href="#" class="card-header-action btn-setting">
            <a @click="addSoal">
              <CIcon name="cil-plus" />
            </a>
          </CLink>
        </div>
      </CCardHeader>
      <CCardBody>
        <div style="overflow: auto">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>No</th>
                <th>Image</th>
                <th>Title</th>
                <th>Description</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(d, k) in data.data"
                :key="k"
                v-show="!d.deleted_at.valid"
              >
                <td>{{ k + 1 }}</td>
                <img
                  :src="d.image_url"
                  alt=""
                  height="200px"
                  style="border: 1px solid #ccc"
                />
                <td>{{ d.title }}</td>
                <td>{{ d.description }}</td>
                <td>
                  <CBadge color="success" v-show="!d.deleted_at.valid"
                    >Active</CBadge
                  >
                  <CBadge color="danger" v-show="d.deleted_at.valid"
                    >Deleted</CBadge
                  >
                </td>
                <td class="action">
                  <btn-edit @click="doEdit(d.id)" />
                  <btn-delete
                    @click="doDelete(d.id)"
                    v-show="!d.deleted_at.valid"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </CCardBody>
      <CCardFooter>
        <content-pagination
          :page="paginate.page"
          :size="paginate.size"
          :total="paginate.total"
          @input="loadPage"
        />
      </CCardFooter>
    </CCard>
  </div>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import ContentPagination from "../../components/ContentPagination";
import BtnEdit from "../../components/BtnEdit";
import BtnDelete from "../../components/BtnDelete";
import { showErrorMessage } from "../../lib/helpers";
export default {
  components: {
    ContentPagination,
    BtnEdit,
    BtnDelete,
  },
  data() {
    return {
      data: {},
      paginate: {},
    };
  },
  created() {
    this.load(1);
  },
  methods: {
    load(page) {
      HTTPAUTH.get(`/api/admin/slider?page=${page}&size=10`)
        .then((res) => {
          this.data = res.data;
          this.paginate = this.data.paginate;
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    loadPage(page) {
      this.load(page);
    },
    addSoal() {
      this.$router.push({ path: "/slider/add/new" });
    },
    doDelete(id) {
      HTTPAUTH.delete("/api/admin/slider/" + id)
        .then((res) => {
          this.$toasted.success("Berhasil menghapus slider").goAway();
          this.load(1);
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    doEdit(id) {
      this.$router.push({ path: "/slider/add/" + id });
    },
  },
};
</script>